var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6086_224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5925 19.9996C40.5925 31.0463 31.6385 40 20.592 40C9.54633 40 0.592529 31.0463 0.592529 19.9996C0.592529 8.95386 9.54633 0 20.592 0C31.6385 0 40.5925 8.95386 40.5925 19.9996Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8775 15.764L23.673 20.558C24.3652 21.251 25.489 21.251 26.1829 20.558C26.8753 19.8648 26.8769 18.7419 26.1829 18.0488L21.3872 13.253C17.9557 9.82092 12.4098 9.76569 8.90563 13.0787C8.87325 13.106 8.84086 13.1346 8.81105 13.1644C8.79583 13.1798 8.78331 13.196 8.76809 13.2097C8.75234 13.2247 8.7366 13.2382 8.72163 13.2532C8.69144 13.2834 8.6637 13.315 8.63725 13.3465C5.32254 16.8523 5.37957 22.3983 8.81118 25.8303L13.6069 30.6248C14.3006 31.3176 15.4229 31.3176 16.1165 30.6248C16.8107 29.9316 16.8107 28.8072 16.1183 28.1156L11.3225 23.32C9.22899 21.2274 9.21493 17.8311 11.2791 15.7205C13.3894 13.6564 16.7838 13.6714 18.8775 15.764ZM25.0669 9.37769C24.3739 10.071 24.3739 11.1937 25.0687 11.8869L29.8627 16.6826C31.9549 18.7752 31.9685 22.171 29.9045 24.2821C27.7935 26.3444 24.4002 26.3309 22.3072 24.238L17.5116 19.4429C16.818 18.7496 15.6939 18.7496 15.0012 19.4429C14.3071 20.1355 14.3071 21.2618 15.0012 21.953L19.7953 26.7489C23.2278 30.1809 28.7731 30.2368 32.2779 26.9232C32.3104 26.8946 32.3411 26.8679 32.3734 26.8376C32.388 26.8227 32.4016 26.8075 32.416 26.7923C32.4314 26.7774 32.4467 26.7636 32.4612 26.7471C32.492 26.7185 32.5183 26.687 32.5456 26.6542C35.8605 23.1498 35.8051 17.6056 32.3734 14.1716L27.5778 9.37756C26.8847 8.68337 25.7593 8.68337 25.0669 9.37769Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6086_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.592529)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthyLogo);
export default __webpack_public_path__ + "static/media/authy-logo.e20742b9b73b8fe6760cf1e0e0e1899c.svg";
export { ForwardRef as ReactComponent };